import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { features } from '../../constants/feature-toggling.const';
import { FeatureTogglingService } from '../../services/feature-toggling/feature-toggling.service';

@Directive({
  selector: '[appFeatureToggling]',
})
export class FeatureTogglingDirective implements OnInit {
  private feature: string = '';
  features = features;

  constructor(
    private templateRef: TemplateRef<void>,
    private viewContainer: ViewContainerRef,
    private featureTogglingService: FeatureTogglingService
  ) {}

  @Input() set appFeatureToggling(feature: string) {
    this.feature = feature;
  }

  ngOnInit(): void {
    if (this.isEnabled()) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  isEnabled(): boolean {
    return this.featureTogglingService.isFeatureAllowed(
      this.feature,
      this.features
    );
  }
}
